import "./App.css";
import Dictionary from "./Dictionary";

function App() {
  return (
    <div className="App">
      <div className="App">
        <header className="App-header">Dictionary</header>
        <main>
          <Dictionary defaultKeyword="wine" />
        </main>
        <footer className="App-footer">Coded by Heather Vanderberg</footer>
      </div>
    </div>
  );
}

export default App;
